import { CONFIG_PARAMS } from '@Components/app-config/types'

export const LOCAL_HOST_CONFIG: Record<string, Record<string, string>> = {
  'msl-test': {
    [CONFIG_PARAMS.GAME_DATA_API_KEY]: '295cc1cb-8b7e-4c52-85c1-186a98e20f28',
    [CONFIG_PARAMS.GAME_DATA_SERVICE_URL]: 'https://test.game-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_SERVICE_URL]: 'https://test.player-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_API_KEY]: 'cc2103e0-1e99-4e63-a255-a49cacf0c775',
    [CONFIG_PARAMS.CLIENT_ID]: '683fb627-b49e-4069-9e93-30e6387efba4',
    [CONFIG_PARAMS.RAPID_GAME_ID]: '7be5c3a9-d2f8-4ebe-92d1-4a13bf931237',
  },
  nhl: {
    [CONFIG_PARAMS.GAME_DATA_API_KEY]: '84b5e8e2-4ee4-49b6-b3c8-5409facf5b8a',
    [CONFIG_PARAMS.GAME_DATA_SERVICE_URL]: 'https://test.game-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_SERVICE_URL]: 'https://test.player-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_API_KEY]: '55297951-c80d-427d-b116-f1e1f19f3d01',
    [CONFIG_PARAMS.CLIENT_ID]: 'c433bf9b-12de-432a-8c9d-693e401465c6',
    [CONFIG_PARAMS.RAPID_GAME_ID]: '340f8ef8-b830-4b92-ac8b-d8ad3edc8c45',
  },
  mslc: {
    [CONFIG_PARAMS.GAME_DATA_API_KEY]: 'c47c7504-e290-40f3-8ec1-d5ddbef4500d',
    [CONFIG_PARAMS.GAME_DATA_SERVICE_URL]: 'https://test.game-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_SERVICE_URL]: 'https://test.player-data.gambytservices.com',
    [CONFIG_PARAMS.PLAYER_DATA_API_KEY]: 'cfcda7d5-795c-4512-b150-edae65513e8d',
    [CONFIG_PARAMS.CLIENT_ID]: '15e57073-763f-40f6-9421-611b81bc528a',
    [CONFIG_PARAMS.RAPID_GAME_ID]: 'd0045d10-8585-4cf2-ac27-cfc530909e21',
  },
}
